<div class="spinner_loader">
  <app-svg-icon [path]="'assets/gifs/spinner.svg'" [ngStyle]="mergedSpinnerStyle"></app-svg-icon>
</div>
